import React from "react";
import { Menu, MenuItem, Typography } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";

interface DatabaseSelectionMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  databases: {
    [key: string]: { name: string; database: string; type: string };
  };
  selectedDatabase: string;
  onDatabaseSelect: (database: string) => void;
  isLoadingDatabase: boolean;
}

const DatabaseSelectionMenu: React.FC<DatabaseSelectionMenuProps> = ({
  anchorEl,
  open,
  onClose,
  databases,
  selectedDatabase,
  onDatabaseSelect,
  isLoadingDatabase,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      autoFocus={false}
      slotProps={{
        paper: {
          sx: {
            backdropFilter: 'blur(20px)',
            background: 'rgba(255,255,255,0.7)',
            borderRadius: '12px',
            border: '1px solid rgba(255,255,255,0.3)',
          },
        },
      }}
    >
      {Object.entries(databases).map(([key, database]) => (
        <MenuItem
          key={key}
          onClick={() => onDatabaseSelect(key)}
          disabled={isLoadingDatabase || database?.type === "maintenance"}
        >
          <CheckOutlinedIcon
            sx={{
              mr: 1,
              fontSize: 16,
              color: "primary.main",
              visibility: selectedDatabase === key ? "visible" : "hidden",
            }}
          />
          <Typography variant="body2">{database.name}</Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default DatabaseSelectionMenu;
